<div class ="main">
    <div class ="header">
        <iframe src="https://3dwarehouse.sketchup.com/embed/a4604a26-65f5-4e8c-a1fc-4d929fa59a24" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" width="100%" height="100%" allowfullscreen></iframe> 
        <audio autoplay loop src="./../../assets/Audios/housebg.mp3"></audio>
    </div>
</div>
